import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // { role: 'admin' | 'client', name: string }

  const login = (username, password) => {
    const normalizedUsername = username.toLowerCase();
    
    if (normalizedUsername === 'dextertarun' && password === 'HaRdIk321@#') {
      setUser({ role: 'admin', name: 'Dexter Admin (Tarun)' });
      return true;
    } else if (normalizedUsername === 'kovarandyork' && password === 'Kr321@') {
      setUser({ role: 'client', name: 'KovaRandYork (KR)' });
      return true;
    }
    return false;
  };

  const logout = () => setUser(null);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
